import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// In-memory token is the primary fallback for embedded/preview contexts where
// SameSite=None/Partitioned cookies AND localStorage can both be blocked.
let memToken = null;
try {
  memToken = localStorage.getItem("ns_token");
} catch {
  memToken = null;
}

export function setToken(token) {
  memToken = token || null;
  try {
    if (token) localStorage.setItem("ns_token", token);
    else localStorage.removeItem("ns_token");
  } catch {
    /* storage unavailable — in-memory token still applies */
  }
}

export function getToken() {
  return memToken;
}

api.interceptors.request.use((config) => {
  if (memToken) config.headers.Authorization = `Bearer ${memToken}`;
  return config;
});

// Any unauthenticated API response forces the user back to the login page.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/reset-password") {
        setToken(null);
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
